import SkillTags from "./SkillTags";

function ProjectCard({ href, image, alt, title, description, skills }) {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <a href={href} target="_blank" rel="noreferrer">
        <div className="project-card">
          <img src={image} alt={alt} />
          <h5>
            {title} <span>&#187;</span>
          </h5>
          <p className="subtle">{description}</p>
          <SkillTags skills={skills} />
        </div>
      </a>
    </div>
  );
}

export default ProjectCard;
